var _defs, _path, _circle, _path2, _circle2, _rect, _circle3, _rect2, _circle4, _rect3, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphicLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "graphic1_left",
    "data-name": "graphic1 left",
    xmlns: "http://www.w3.org/2000/svg",
    width: 316,
    height: 575,
    viewBox: "0 -90 316 575",
    preserveAspectRatio: "xMinYMin meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .login-bg-left-cls-1, .login-bg-left-cls-2 {\n        fill: #ee162d;\n      }\n\n      .login-bg-left-cls-1, .login-bg-left-cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .login-bg-left-cls-1, .login-bg-left-cls-3, .login-bg-left-cls-5 {\n        opacity: 0.5;\n      }\n\n      .login-bg-left-cls-3, .login-bg-left-cls-5 {\n        fill: #d4c527;\n      }\n\n      .login-bg-left-cls-4 {\n        fill: #424143;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_5",
    "data-name": "Rectangle 2 copy 5",
    className: "login-bg-left-cls-3",
    d: "M3558,2351H3276v-10h282a40,40,0,0,0,0-80H3427v-10h131A50,50,0,0,1,3558,2351Z",
    transform: "translate(-3292 -2100)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_5",
    "data-name": "Ellipse 1 copy 5",
    className: "login-bg-left-cls-2",
    cx: 135,
    cy: 156,
    r: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8",
    "data-name": "Rectangle 2 copy 8",
    className: "login-bg-left-cls-1",
    d: "M3505,2585h-46v-10h46a35,35,0,0,0,0-70H3276v-10h229A45,45,0,0,1,3505,2585Z",
    transform: "translate(-3292 -2100)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_10",
    "data-name": "Ellipse 1 copy 10",
    className: "login-bg-left-cls-2",
    cx: 168,
    cy: 480,
    r: 5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "login-bg-left-cls-4",
    x: -16,
    y: 315,
    width: 233,
    height: 10
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_6",
    "data-name": "Ellipse 1 copy 6",
    className: "login-bg-left-cls-2",
    cx: 217,
    cy: 320,
    r: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3_copy_3",
    "data-name": "Rectangle 3 copy 3",
    className: "login-bg-left-cls-1",
    x: -16,
    width: 184,
    height: 10
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_12",
    "data-name": "Ellipse 1 copy 12",
    className: "login-bg-left-cls-2",
    cx: 168,
    cy: 5,
    r: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3_copy_2",
    "data-name": "Rectangle 3 copy 2",
    className: "login-bg-left-cls-4",
    x: -16,
    y: 83,
    width: 93,
    height: 10
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_9",
    "data-name": "Ellipse 1 copy 9",
    className: "login-bg-left-cls-2",
    cx: 77,
    cy: 88,
    r: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicLeft);
export default __webpack_public_path__ + "static/media/graphic-left.71eed0973e1041b026dce80312cc5bc8.svg";
export { ForwardRef as ReactComponent };